module.exports = {"id":"dp5_4l3q3","text":"Assessing Digital Competence Needs","instructions":"Which approach best supports meeting digital learning needs?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.4","questionType":"PickOne","random":true,"options":[{"id":"dp5_4l3q3-a1","text":"Planned learning","score":3},{"id":"dp5_4l3q3-a2","text":"Occasional practice","score":0.6},{"id":"dp5_4l3q3-a3","text":"Random exposure","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.4/l3q3.json
// module id = 1346
// module chunks = 41